/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/generate/GenerateRandomString.ts
 * @create:      2025-06-28 09:39:33.568
 * @modify:      2025-07-11 21:19:12.894
 * @version:     6.0.0
 * @times:       8
 * @lines:       69
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Empty, Strings_LowercaseLetters, Strings_Numbers, Strings_UppercaseLetters } from "../const/Strings";
import { GenerateRandomInt } from "./GenerateRandomInt";

/**
 * Generates a random string of the specified length using the provided set of valid characters.
 *
 * @param length - The desired length of the generated string.
 * @param validCharacters - (Optional) A string containing the set of characters to use for generating the random string.
 *                          If not provided or if its length is less than 2, a default set of lowercase letters,
 *                          uppercase letters, and numbers will be used.
 * @returns A randomly generated string of the specified length.
 * 
 * @version 1.0.0
 * @since 1.0.5
 */
export function GenerateRandomString(length: number, validCharacters?: string) {
    let str: string = Strings_Empty;

    if (validCharacters === undefined || validCharacters.length < 2) {
        validCharacters =
            Strings_LowercaseLetters +
            Strings_UppercaseLetters +
            Strings_Numbers;
    }

    for (let i = 0; i < length; i++) {
        const char = validCharacters[GenerateRandomInt(0, validCharacters.length - 1)];
        if (str === Strings_Empty) {
            str = char;
        } else {
            str += char;
        }
    }

    return str;
}
